<template>
    <div class="consult-button-wrapper">
        <el-button icon="el-icon-service" circle class="consult-button" @click="toggleConsult">
        </el-button>
        <div v-if="isConsultOpen" class="consult-popup" v-loading="isLoading"
            element-loading-background="rgba(0, 0, 0, 0.1)">
            <el-button icon="el-icon-close" class="close-button" @click="toggleConsult"></el-button>
            <iframe class="consult-iframe" :src="iframeSrc" frameborder="0" @load="handleLoad"></iframe>
        </div>
    </div>
</template>

<script>
export default {
    name: "ConsultButton",
    data() {
        return {
            isConsultOpen: false,
            isLoading: false,
            iframeSrc: ""
        };
    },
    methods: {
        toggleConsult() {
            this.isConsultOpen = !this.isConsultOpen;
            if (this.isConsultOpen) {
                this.isLoading = true;
                if (process.env.VUE_APP_ENV && process.env.VUE_APP_ENV.endsWith(".kr")) {
                    this.iframeSrc = `https://console.fplusai.com/chat?t=${Date.now()}`;
                } else {
                    this.iframeSrc = `https://console.fplusai.com.cn/chat?t=${Date.now()}`;
                }
            }
        },
        handleLoad() {
            this.isLoading = false;
        }
    },
};
</script>

<style scoped>
.consult-button-wrapper {
    position: fixed;
    bottom: 26px;
    right: 24px;
    z-index: 1000;

    .consult-button {
        color: white;
        background-color: #202d31;
        padding: 12px 12px;
        font-size: 26px;
        cursor: pointer;
        border: 0;
        box-shadow: rgba(0, 0, 0, 0.25) 0px 6px 10px 0px;
    }

    .consult-button:hover {
        background-color: #101330;
    }

    .consult-popup {
        position: fixed;
        bottom: 20px;
        right: 20px;
        width: 400px;
        height: 600px;
        background-color: white;
        border: 1px solid #ddd;
        border-radius: 10px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
        z-index: 1001;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .close-button {
        color: white;
        position: absolute;
        top: 5px;
        right: 0;
        background: none;
        border: none;
        font-size: 20px;
        cursor: pointer;
        z-index: 1002;
    }

    .consult-iframe {
        flex: 1;
        width: 100%;
        height: 100%;
        border: none;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
    }
}
</style>